export const products = [
  {
    id: 1,
    img: "https://www.dropbox.com/s/jeczj3iw5jmx5te/Screen%20Shot%202022-04-27%20at%202.45.32%20PM.png?raw=1",
    link: "https://movie-fighta4.herokuapp.com/",
  },
  {
    id: 2,
    img: "https://www.dropbox.com/s/f9u7r0rxl5q4kbu/Screen%20Shot%202022-04-27%20at%203.46.44%20PM.png?raw=1",
    link: "https://jenperez.dev/museum-of-candy/",
  },
  {
    id: 3,
    img: "https://www.dropbox.com/s/ukjt81yfr6y87h1/owlpixblogss.jpg.png?raw=1",
    link: "https://owlpix.herokuapp.com/",
  },
  {
    id: 4,
    img: "https://www.dropbox.com/s/j0oqo7zfl1gv3lu/Screen%20Shot%202022-04-27%20at%2011.29.07%20PM.png?raw=1",
    link: "https://susapp.netlify.app/login",
  },
  {
    id: 5,
    img: "https://www.dropbox.com/s/p99wl1933hyza0z/Screen%20Shot%202022-04-27%20at%203.49.41%20PM.png?raw=1",
    link: "http://jenperez.dev/Timer-javascript/",
  },
  {
    id: 6,
    img: "https://www.dropbox.com/s/yp4r2auul24psdy/Screen%20Shot%202022-04-27%20at%203.48.59%20PM.png?raw=1",
    link: "http://jenperez.dev/HoverButton/",
  },
];
